import { render, staticRenderFns } from "./CreateMaClass.vue?vue&type=template&id=14317672&scoped=true"
import script from "./CreateMaClass.vue?vue&type=script&lang=js"
export * from "./CreateMaClass.vue?vue&type=script&lang=js"
import style0 from "./CreateMaClass.vue?vue&type=style&index=0&id=14317672&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14317672",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14317672')) {
      api.createRecord('14317672', component.options)
    } else {
      api.reload('14317672', component.options)
    }
    module.hot.accept("./CreateMaClass.vue?vue&type=template&id=14317672&scoped=true", function () {
      api.rerender('14317672', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/MaClassDialog/CreateMaClass.vue"
export default component.exports